/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckExternalBranchItemsResponse } from '../models/CheckExternalBranchItemsResponse';
import type { ExternalBranchAdminDto } from '../models/ExternalBranchAdminDto';
import type { Pagination1OfExternalBranchListedAdminDto } from '../models/Pagination1OfExternalBranchListedAdminDto';
import type { PostExternalBranchRequestAdmin } from '../models/PostExternalBranchRequestAdmin';
import type { PutExternalBranchRequestAdmin } from '../models/PutExternalBranchRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalBranchesService {
    /**
     * @returns CheckExternalBranchItemsResponse OK
     * @throws ApiError
     */
    public static checkExternalBranchIntegrationPartner(): CancelablePromise<CheckExternalBranchItemsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner/v1/external-branches/public/check',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns ExternalBranchAdminDto OK
     * @throws ApiError
     */
    public static createExternalBranchAsyncAdmin({
        requestBody,
    }: {
        requestBody?: PostExternalBranchRequestAdmin,
    }): CancelablePromise<ExternalBranchAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/externalbranches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfExternalBranchListedAdminDto OK
     * @throws ApiError
     */
    public static getExternalBranchesAsyncAdmin({
        page,
        limit,
    }: {
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfExternalBranchListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/externalbranches',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ExternalBranchAdminDto OK
     * @throws ApiError
     */
    public static updateExternalBranchAsyncAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutExternalBranchRequestAdmin,
    }): CancelablePromise<ExternalBranchAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/externalbranches/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteExternalBranchAsyncAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/externalbranches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ExternalBranchAdminDto OK
     * @throws ApiError
     */
    public static getExternalBranchByIdAsyncAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ExternalBranchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/externalbranches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CheckExternalBranchItemsResponse OK
     * @throws ApiError
     */
    public static postCheckExternalBranchItemsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CheckExternalBranchItemsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/externalbranches/{id}/check',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
